import { useLocation } from "react-router-dom";
import PageMeta from "@/components/PageMeta";


const metadata = {
  "/": ["AeroCore Scripts | FiveM Aviation Systems", "Purpose-built aviation scripts and systems for FiveM servers, delivered securely through Tebex."],
  "/products": ["FiveM Aviation Scripts", "Browse AeroCore aviation scripts and systems for FiveM servers."],
  "/about": ["About AeroCore Scripts", "Learn how AeroCore approaches focused, dependable aviation systems for FiveM communities."],
  "/contact": ["Contact AeroCore Scripts", "Contact AeroCore Scripts for product, installation, and purchase support."],
  "/cart": ["Your Basket | AeroCore Scripts", "Review your AeroCore Scripts basket and continue to secure Tebex checkout."],
  "/terms": ["Terms of Service", "Terms for using the AeroCore Scripts website and purchasing digital FiveM products."],
  "/privacy": ["Privacy Policy", "How AeroCore Scripts handles checkout, account, contact, and technical data."],
  "/refund-policy": ["Refund Policy", "Refund and purchase-support information for AeroCore Scripts digital products."],
};

const RouteMeta = () => {
  const { pathname } = useLocation();
  const isPrivate = pathname.startsWith("/admin") || pathname.startsWith("/checkout") || pathname.startsWith("/account") || pathname === "/cart";
  const [title, description] = metadata[pathname] || (
    pathname.startsWith("/product/")
      ? ["FiveM Script", "View product details and continue to secure Tebex checkout."]
      : ["AeroCore Scripts", "Purpose-built aviation scripts and systems for FiveM servers."]
  );
  return <PageMeta title={title} description={description} path={pathname} noindex={isPrivate} />;
};

export default RouteMeta;
